import { useMemo } from 'react'

import { useFormContext, useWatch } from 'react-hook-form'

import { TransferFormValues } from '~/components/forms/transfer/transferSchema'
import { isVaultToken } from '~/utils/vault'

export const useStateChangesToHide = () => {
  const methods = useFormContext<TransferFormValues>()

  const sender = useWatch({ control: methods.control, name: 'sender' })
  const recipients = useWatch({ control: methods.control, name: 'recipients' })
  const transferToken = useWatch({
    control: methods.control,
    name: 'transferToken',
  })
  const earnToken = useWatch({
    control: methods.control,
    name: 'swapData.earnToken',
  })

  return useMemo(() => {
    // Currently we only want to hide state changes for earn token because of dust.
    if (earnToken && transferToken?.token) {
      if (transferToken.token === earnToken.token) {
        // This is the same as a withdraw, so don't hide the state change.
        if (sender === recipients[0]?.receiver?.address) return undefined
        else {
          // If the receiver is not the sender, hide the internal state change (USDC ZAP -> USDC) for the sender.
          return {
            [sender]: { [earnToken.token]: true },
          }
        }
      } else if (!isVaultToken(transferToken.chainId, transferToken.token)) {
        // If the earn token is not the same as the transfer token and the transfer token is not a vault token, hide the state change for the sender.
        return {
          [sender]: { [earnToken.token]: true },
        }
      }
    }
    return undefined
  }, [earnToken, sender, recipients, transferToken])
}
